import BubbleSmileGradient from "@/assets/campaign/7086FF_bubble_smile.svg?react";
import Modal from "@/components/Common/Modal";
import {isDeleteTemplateModalOpenAtom} from "@/store/jotaiAtoms";
import {useSetAtom} from "jotai";
import {memo, type FC} from "react";
import {useTranslation} from "react-i18next";

const DeleteTemplateModal: FC<{onDelete: () => void}> = ({onDelete}) => {
  const setShowDeleteTemplateModal = useSetAtom(isDeleteTemplateModalOpenAtom);
  const {t} = useTranslation();

  return (
    <Modal
      onClose={() => {
        setShowDeleteTemplateModal(false);
      }}
      onConfirm={onDelete}
      shouldCloseOnConfirm
      shouldHideModalTitle
      customTitleRow={
        <div className="flex items-center gap-2 p-5">
          <BubbleSmileGradient className="size-5 shrink-0" />
          <span className="text-neutral-black text-xl font-semibold">{t("delete_template")}</span>
        </div>
      }>
      <div className="flex items-center justify-center text-xl font-semibold">{t("delete_template_confirmation")}</div>
    </Modal>
  );
};

export default memo(DeleteTemplateModal);
